import "./App.scss";
import Footer from "./components/footer";
import Cart from "./pages/cart";
import Home from "./pages/home";
import { Routes, Route } from "react-router-dom";
import Order from "./pages/order";
import Menu from "./pages/menu";
import Header from "./components/header";
import { useEffect, useMemo, useState } from "react";
import { getMenuData } from "./apiServices";
import Context from "./context";
import OrderTracking from "./pages/orderTracking";

function App() {
  const [foodMenuData, setFoodMenuData] = useState([]);
  const [cartItems, setCartItems] = useState([]);

  const value = useMemo(
    () => ({ cartItems, setCartItems, foodMenuData, setFoodMenuData }),
    [cartItems, foodMenuData]
  );

  const getFoodMenu = async () => {
    const res = await getMenuData();
    if (res.data) {
      setFoodMenuData(res.data);
    }
  };

  // useEffect(() => {
  //   if (!foodMenuData.length) {
  //     getFoodMenu();
  //   }
  // }, [foodMenuData.length]);
  return (
    <>
      <Header cartItems={cartItems} />
      <div className="content">
        <Context.Provider value={value}>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/menu" element={<Menu />} /> */}
            {/* <Route path="/order" element={<Order />} /> */}
            {/* <Route path="/reservation" element={<Reservation />} /> */}
            <Route path="/about" element={<Home />} />
            <Route path="/contact" element={<Home />} />
            {/* <Route path="/login" element={<Login />} /> */}
            {/* <Route path="/cart" element={<Cart />} /> */}
            {/* <Route path="/orderTracking" element={<OrderTracking />} /> */}
          </Routes>
        </Context.Provider>
      </div>
      <Footer />
    </>
  );
}

export default App;
